import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const Link = styled(RouterLink)<{ disabled?: boolean }>`
  pointer-events: ${({ disabled }): string => (disabled ? 'none' : 'auto')};
`;
